import { render, staticRenderFns } from "./faceExamineResult.vue?vue&type=template&id=4eaa4a2c&scoped=true"
import script from "./faceExamineResult.vue?vue&type=script&lang=js"
export * from "./faceExamineResult.vue?vue&type=script&lang=js"
import style0 from "./faceExamineResult.vue?vue&type=style&index=0&id=4eaa4a2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa4a2c",
  null
  
)

export default component.exports